export default __webpack_public_path__ + "static/media/pexels-negative-space-169573.c3fa9cad.jpg";